module.exports = __webpack_public_path__ + "static/img/1设计师1.afe0672.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/1设计师1.png
// module id = l5WR
// module chunks = 1